import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/departamento/importer/departamentoImporterActions';

export default importerReducers(actions);
